import type { EditorVariant } from './markdown-editor.interface'

/**
 * HTML attributes for TipTap editor elements styling
 */
export const tiptapHtmlAttributes = {
  codeBlock: { class: 'rounded-md bg-muted p-4 font-mono text-sm' },
  blockquote: { class: 'border-l-4 border-border pl-4 italic' },
  link: { class: 'text-primary underline underline-offset-2 hover:text-primary/80' },
  taskList: { class: 'list-none pl-0' },
  taskItem: { class: 'flex items-start gap-2' },
  table: { class: 'border-collapse border border-border w-full' },
  tableHeader: { class: 'border border-border bg-muted px-3 py-2 text-left font-semibold' },
  tableCell: { class: 'border border-border px-3 py-2' },
  highlight: { class: 'bg-yellow-200 dark:bg-yellow-800' },
} as const

/**
 * Variant-specific CSS classes for the editor content area
 */
const variantStyles: Record<EditorVariant, string> = {
  full: 'min-h-[200px] px-4 py-3',
  compact: 'min-h-[120px] px-3 py-2 text-sm',
  chat: 'min-h-[80px] px-3 py-2',
  inline: 'min-h-[40px] px-2 py-1 text-sm',
} as const

/**
 * Returns CSS classes based on editor variant
 */
export const getVariantClasses = (variant: EditorVariant): string => variantStyles[variant]
